import { render, staticRenderFns } from "./LiveChatPage.vue?vue&type=template&id=49aca542&scoped=true"
import script from "./LiveChatPage.vue?vue&type=script&lang=js"
export * from "./LiveChatPage.vue?vue&type=script&lang=js"
import style0 from "./LiveChatPage.vue?vue&type=style&index=0&id=49aca542&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49aca542",
  null
  
)

export default component.exports